import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: start;
	gap: var(--spacing-medium);
	min-width: 0;
`;
